import { gql } from "@apollo/client"

// more on fragments: https://dev.to/darksmile92/how-to-use-graphql-fragments-with-apollo-dh4
export const FRAGMENT_CRITICALITY_QUESTION_ANSWERS = gql`
  fragment criticalityQuestionAnswers on CriticalFunction {
    criticalityQuestionAnswers {
      causeLegalHarm
      causeLegalHarmComment
      causePenaltiesOrFines
      causePenaltiesOrFinesComment
      harmReputation
      harmReputationComment
      impactStudents
      impactStudentsComment
      lossOfRevenue
      lossOfRevenueComment
      protectLifeProperty
      protectLifePropertyComment
    }
  }
`
// mutation to update Critical Function
export const UPDATE_CRITICAL_FUCTION = gql`
  mutation UpdateCriticalFunction(
    $id: Int!
    $agreeWithSuggestedCriticality: Boolean
    $levelOfCriticalityExplanation: String
    $levelOfCriticality: Int
    $recoveryTimeObjectiveId: Int!
    $criticalityQuestionAnswers: CriticalFunctionCriticalityQuestionAnswersInput!
  ) {
    updateCriticalFunction(
      input: {
        id: $id
        agreeWithSuggestedCriticality: $agreeWithSuggestedCriticality
        levelOfCriticality: $levelOfCriticality
        levelOfCriticalityExplanation: $levelOfCriticalityExplanation
        recoveryTimeObjectiveId: $recoveryTimeObjectiveId
        criticalityQuestionAnswers: $criticalityQuestionAnswers
      }
    ) {
      id
      suggestedLevelOfCriticality
      levelOfCriticality
      agreeWithSuggestedCriticality
      levelOfCriticalityExplanation
      ...criticalityQuestionAnswers
    }
  }
  ${FRAGMENT_CRITICALITY_QUESTION_ANSWERS}
`

// query to get Critical Function including Recovery Time Objectives
// and Settings
export const GET_CRITICAL_FUNCTION = gql`
  query GetCriticalFunction($id: ID!) {
    criticalFunction(id: $id) {
      id
      function
      agreeWithSuggestedCriticality
      levelOfCriticality
      suggestedLevelOfCriticality
      levelOfCriticalityExplanation
      recoveryTimeObjective {
        id
      }
      ...criticalityQuestionAnswers
    }
    recoveryTimeObjectives {
      timePeriod
      id
    }
    setting {
      item1
      item2
      item3
      item4
      term1
      term2
      term3
      term4
    }
  }
  ${FRAGMENT_CRITICALITY_QUESTION_ANSWERS}
`

// standalone query to get Recovery Time Objectives
export const GET_RECOVERY_TIME_OBJECTIVES = gql`
  query GetRecoveryTimeObjectives {
    recoveryTimeObjectives {
      id
      timePeriod
      position
    }
  }
`
